import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  SpanStyled,
  TextStyled,
} from "../../../styled/Elements";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import useAuth from "../../../../context/authContext";
import { useState } from "react";

const LogoutModal = ({ show, onHide }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  async function handleLogout() {
    setIsLoading(true);
    try {
      const { code, message } = await AuthApi.logout();
      if (code === 200) {
        toast.success(message);
        logout();
      }
    } catch (error) {}finally {
      setIsLoading(false);
    }
  }
  return (
    <Modal show={show} onHide={onHide} centered>
      <LogoutModalWrapper>
        <Box className="p-4">
          <Box className="mb-4">
            <Box>
              <SpanStyled size="20px" weight={800} color="var(--themeColor)">
                {t("Logout")}
              </SpanStyled>
              <TextStyled size="16px" color="var(--text2)">
                {t("sureLogout")}
              </TextStyled>
            </Box>
          </Box>
          <Box className="d-flex justify-content-end">
            <Box className="mt-4 d-flex gap-3">
              <ButtonStyled
                label={t("No_Keep_it")}
                bg={"var(--bgSecondary)"}
                color={"var(--text2)"}
                onClick={onHide}
              />
              <ButtonStyled
                label={t("Yes_Logout")}
                bg="var(--themeColor2)"
                onClick={handleLogout}
                isLoading={isLoading}
              />
            </Box>
          </Box>
        </Box>
      </LogoutModalWrapper>
    </Modal>
  );
};

export default LogoutModal;

const LogoutModalWrapper = styled.div``;
